import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { applyMiddleware, createStore, Middleware, MiddlewareAPI, Dispatch, AnyAction } from "redux";

import { rootReducer, IStoreState } from "./reducers/root.reducer";
import {composeWithDevTools} from "@redux-devtools/extension";

const storageMiddleware : Middleware<{}, IStoreState> = (api: MiddlewareAPI) => (next: Dispatch<AnyAction>) => (x: any) => {
  const y = next(x)
  let newState = api.getState();
  window.sessionStorage.setItem('_state', JSON.stringify(newState))
  return y;
}

export const configureStore = (history: any) => {
  const middleware = [thunk, routerMiddleware(history), storageMiddleware];

  const isProduction = process.env.NODE_ENV === "production";

  const state = window.sessionStorage.getItem('_state');

  if (state) {
    return createStore(
      rootReducer,
      JSON.parse(state),
      isProduction
        ? applyMiddleware(...middleware)
        : composeWithDevTools(applyMiddleware(...middleware))
    );
  }
  return createStore(
    rootReducer,
    isProduction
      ? applyMiddleware(...middleware)
      : composeWithDevTools(applyMiddleware(...middleware))
  );
};
